module Arkadium.Core {
	"use strict"

	export class AnalyticsManager {

		static Providers = {
			AMPLITUDE: "analyticsProvider.amplitude",
			GOOGLE: "analyticsProvider.google"
		};

		private _impl: any;
		private _config: any;

		constructor() {
			this._impl = null;
		};

		init(config) {
			this._config = config;
			this.createImplementation();
		};

		createImplementation() {
			var provider = this._config.provider;
			switch (provider) {
				case AnalyticsManager.Providers.AMPLITUDE: {
					this._impl = new ImplAmplitude(this._config);
					break;
				}
				case AnalyticsManager.Providers.GOOGLE: {
					this._impl = new ImplGoogle(this._config);
					break;
				}
			}

			if (this._impl !== null) {
				this._impl.init();
			}
		};

		logPageview(eventName, params) {
			if (this._impl !== null) {
				this._impl.logPageview(eventName, params);
			}
		};

		logEvent(eventName, params) {
			if (this._impl !== null) {
				this._impl.logEvent(eventName, params);
			}
		};
	}
}



// WEBPACK FOOTER //
// src/typescript/Core/Analytics/AnalyticsManager.ts